import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_g-lte",
  "use": "svg_g-lte-usage",
  "viewBox": "0 0 11.3 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11.3 18\" id=\"svg_g-lte\"><path class=\"st0\" d=\"M8.9 3.6c-1.8-1.8-4.7-1.8-6.5 0l.8.8C4.5 3 6.7 3 8.1 4.4l.8-.8z\" /><path class=\"st0\" d=\"m4 5.2.8.8c.4-.5 1.2-.5 1.7 0l.8-.8c-.9-1-2.4-1-3.3 0zM1.6 2.8C3.8.6 7.5.6 9.7 2.8l.8-.8C7.8-.7 3.5-.7.8 2l.8.8zM6.1 6.7h-1L0 18h1.2l.6-1.4 3.8-3.5 3.8 3.5.6 1.4h1.2L6.1 6.7zm-3 7.3 1-2.3.7.7L3.1 14zm2.5-2.4-1-1 1-2.3 1 2.3-1 1zm.9.7.7-.7 1 2.3-1.7-1.6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol